import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.projects.data.FranchiseeProjectManager.';
  public static readonly createdQuoteForProject = `${Id.prefix}createdQuoteForProject`;
  public static readonly unableToCreateQuoteForProject = `${Id.prefix}unableToCreateQuoteForProject`;
  public static readonly unableToCreateQuote = `${Id.prefix}unableToCreateQuote`;
}

export class LangFranchiseeProjectManager {
  private constructor() {}
  public static createdQuoteForProject(params: { projectTitle: string }): string {
    return interpolate(Id.createdQuoteForProject, params);
  }
  public static unableToCreateQuoteForProject(params: { projectTitle: string }): string {
    return interpolate(Id.unableToCreateQuoteForProject, params);
  }
  public static unableToCreateQuote(): string {
    return interpolate(Id.unableToCreateQuote);
  }
}

export class FranchiseeProjectManagerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.createdQuoteForProject,
      "Created {{glossary 'quote'}} for {{projectTitle}}",
      'Toast message when a quote is created for a project'
    );
    register.add(
      Id.unableToCreateQuoteForProject,
      "Unable to create {{glossary 'quote'}} for {{projectTitle}}",
      'Toast message when unable to create a quote for a project'
    );
    register.add(
      Id.unableToCreateQuote,
      "Unable to create {{glossary 'quote'}}",
      'Toast message when unable to create a quote'
    );
  }
}
